import { useQuery, useMutation } from "react-query";
import { message } from "antd";
import { useTranslation } from "react-i18next";

import * as api from "apis/career";

//Query untuk get employee careers
export function useEmployeeCareers({ payload = {} }) {
  const { t } = useTranslation();
  return useQuery(
    ["employee/careers", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getEmployeeCareers(payload.id);
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
    }
  );
}

//Query untuk get employee career
export function useEmployeeCareer({ payload = {}, enabled = false }) {
  const { t } = useTranslation();
  return useQuery(
    ["career", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getCareer(payload.id);
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      enabled,
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
    }
  );
}

//Query untuk get effective date employee career
export function useEffectiveDateCareer({ payload = {}, enabled = false }) {
  const { t } = useTranslation();
  return useQuery(
    ["career/effectiveDate", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getEffectiveDateCareer(payload.id);
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      enabled,
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
    }
  );
}

// Query untuk add employee career
export const useAddCareer = () => {
  const { t } = useTranslation();
  return useMutation((payload) => api.addCareer(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) =>
      message.error(t("error.failed_save_data_to_server")),
  });
};

// Query untuk edit employee career
export const useEditCareer = () => {
  const { t } = useTranslation();
  return useMutation((payload) => api.editCareer(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) =>
      message.error(t("error.failed_save_data_to_server")),
  });
};

// Query untuk delete employee career
export const useDeleteCareer = () => {
  const { t } = useTranslation();
  return useMutation((payload) => api.deleteCareer(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) =>
      message.error(t("error.failed_save_data_to_server")),
  });
};
